import { defaultAxios, IParams } from './base';

export interface IGetBaseKeypad extends IParams {
  // condition 없음
}

export const getBaseKeypad = (params: IGetBaseKeypad) => {
  return defaultAxios().post(`/base/keypad`, params);
};
